import { CellContext } from "@tanstack/react-table"
import styled from "styled-components"

import { useAppDispatch } from "store/hooks"
import { showSeeMessageModal } from "store/modalSlise"
import { setSelectedMessageTemplateID } from "store/tempDataSlise"
import { UITypes } from "types"

const SeeMessageButton = styled.span`
  &:hover {
    color: #2db2c8;
    text-decoration: underline;
    cursor: pointer;
  }
`

interface Props {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
}

const MessageCenterSeeMessage = ({ cell: { getValue } }: Props) => {
  const templateId = getValue().value ? Number(getValue().value) : null
  const dispatch = useAppDispatch()

  const handleSeeMessage = () => {
    if (!templateId) return

    dispatch(setSelectedMessageTemplateID(templateId))
    dispatch(showSeeMessageModal(true))
  }

  if (!templateId) return null

  return <SeeMessageButton onClick={handleSeeMessage}>See message</SeeMessageButton>
}

export default MessageCenterSeeMessage
